import type { ComponentPropsWithoutRef } from 'react';
import styles from './Card.module.css';

interface CardProps extends ComponentPropsWithoutRef<'div'> {
  /** A thin coloured bar across the top, as seen on the module overview card. */
  accent?: boolean;
  interactive?: boolean;
}

export function Card({ accent, interactive, className, ...rest }: CardProps): React.JSX.Element {
  const classes = [styles.card, accent && styles.accent, interactive && styles.interactive, className]
    .filter(Boolean)
    .join(' ');
  return <div className={classes} {...rest} />;
}
